import { useEffect } from "react";
import { Field, useField } from "formik";

export default function Checkbox(props) {
  const [field, meta] = useField(props.name);

  useEffect(() => {
    if (field.value === false && props.secondOperation)
      props.secondOperation(true);
    else if (field.value === true && props.secondOperation) {
      props.secondOperation(false);
    }
  }, [field.value]);

  const configTextfield = {
    ...field,
    error: false,
    value: field.value,
  };
  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }

  return (
    <>
      <Field
        name={props.name}
        render={({ form }) => {
          return (
            <div
              className={meta && meta.touched && meta.error ? "error-form" : ""}
            >
              <label>
                <input
                  type="checkbox"
                  id={props.id}
                  name={props.name}
                  checked={field.value}
                  style={{ marginRight: 5 }}
                  {...field}
                />
                {props.text}
              </label>
              {meta && meta.error ? (
                <div className="error">{meta.error}</div>
              ) : null}
            </div>
          );
        }}
      />
    </>
  );
}
